import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { withJwt } from '../../../utils/with-jwt';
import { ignoreData } from '../../../utils/ignore-data';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { AuthHeaders } from '../../../models/auth-headers';
import { fromFetch } from 'rxjs/fetch';

/**
 * Assign a single product license to a specific User
 * @param productId ID of the product to assign
 * @param externalId External ID of the User
 */
export function postLicenseProductId(
  this: unknown,
  productId: number,
  externalId: string
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).licenseUrl}/${encodeURIComponent(
          productId
        )}`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
          body: JSON.stringify({ externalId }),
        }
      )
    )
  ).pipe(ignoreData());
}
